import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Breadcrumb } from 'react-bootstrap';

import { MENU, MARKETING_GUIDELINES_MENU } from '../MenuComponent/MenuConstants';
import { HOME_PATH, WEB_API_PATH, ANDROID_API_PATH, IOS_API_PATH, MARKETING_GUIDELINES_PATH, PROFILE_PATH, LICENSES_PATH, COMPANIES_PATH, SUPPORT_PATH, OVERVIEW_PATH, GUIDES_PATH, INTRODUCTION_GUIDES_PATH, MMS_GUIDES_PATH, REAL_TIME_GUIDES_PATH } from '../../../constants/routes';

import './breadcrumbs.scss';

const BREADCRUMBS = {
    api: {
        title: 'Home',
        url: HOME_PATH,
    },
    android: {
        title: 'Android API',
        url: `${ANDROID_API_PATH}/`,
    },
    ios: {
        title: 'iOS API',
        url: `${IOS_API_PATH}/`,
    },
    web: {
        title: 'Web API',
        url: `${WEB_API_PATH}/`,
    },
    marketing: {
        title: 'Marketing Guidelines',
        url: `${MARKETING_GUIDELINES_PATH}/`,
    },
    profile: {
        title: 'Home',
        url: HOME_PATH,
    },
    update: {
        title: 'Profile',
        url: `${PROFILE_PATH}/`,
    },
    licenses: {
        title: 'Licenses',
        url: `${LICENSES_PATH}/`,
    },
    companies: {
        title: 'Companies',
        url: `${COMPANIES_PATH}/`,
    },
    support: {
        title: 'Support',
        url: `${SUPPORT_PATH}/`,
    },
    overview: {
        title: 'Overview',
        url: `${OVERVIEW_PATH}/`,
    },
    guides: {
        title: 'Guides',
        url: `${GUIDES_PATH}/`,
    },
    introduction: {
        title: 'Introduction',
        url: `${INTRODUCTION_GUIDES_PATH}/`,
    },
    'mms-integration': {
        title: 'MMS Integration',
        url: `${MMS_GUIDES_PATH}/`,
    },
    'real-time-availability': {
        title: 'Real-Time Availability',
        url: `${REAL_TIME_GUIDES_PATH}/`,
    },
    ...MENU,
    ...MARKETING_GUIDELINES_MENU,
};

const getBreadcrumbUrl = (fullPath, { url, subMenu, linkToSelf }) => {
    if (url) {
        return url;
    }

    if (subMenu && !linkToSelf) {
        const firstSubMenuKey = Object.keys(subMenu)[0];
        return firstSubMenuKey ? `${fullPath}/${firstSubMenuKey}` : fullPath;
    }

    return fullPath;
};

class BreadcrumbsComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
        }
    }
    setup = (location) => {
        const items = [];
        let prevKey = '';
        let fullPath = '';

        location.pathname.split('/').forEach((pathname) => {
            if (pathname) {
                let key = pathname;
                let breadcrumb = BREADCRUMBS[key];

                if (!breadcrumb) {
                    breadcrumb = BREADCRUMBS[prevKey].subMenu[key];
                    key = `${prevKey}/${key}`;
                }

                fullPath = fullPath ? `${fullPath}/${pathname}` : `/${pathname}`;

                const { title, ...breadcrumbConfig } = breadcrumb;
                items.push({
                    title,
                    url: getBreadcrumbUrl(fullPath, breadcrumbConfig),
                });
                prevKey = key;
            }
        });

        this.setState({ items });
    }

    componentWillMount() {
        this.setup(this.props.location);
    }

    componentWillReceiveProps({ location }) {
        this.setup(location);
    }

    render() {
        const { items } = this.state;

        return <div className="Breadcrumbs-component">
            <Breadcrumb>
                {items.map(({ url, title }, i) => {
                    const active = i === (items.length - 1)
                    return <Breadcrumb.Item
                        key={i}
                        active={active}
                        onClick={() => !active && this.props.history.push(url)}
                    >
                        <span className={active ? 'breadcrumb-title-active' : 'breadcrumb-title'}>{title}</span>{!active && <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>}
                    </Breadcrumb.Item>
                })}
            </Breadcrumb>
        </div>;
    }
}

BreadcrumbsComponent.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

export default withRouter(BreadcrumbsComponent);



// WEBPACK FOOTER //
// ./src/components/core/BreadcrumbsComponent/BreadcrumbsComponent.js